export enum ChatProviderType {
    ProGPT = 0,
    Assistants = 1,
    Nexus = 2,
}